import { BlogEditorContextMenuActionEnum } from '@doltech/utils/lib/constants';

export const BlogEditorContextMenuPresets: BlogEditorContextMenuActionEnum[] = [
  BlogEditorContextMenuActionEnum.COPY,
  BlogEditorContextMenuActionEnum.PASTE,
  BlogEditorContextMenuActionEnum.PASTE_WITHOUT_FORMAT,
  BlogEditorContextMenuActionEnum.HYPERLINK,
  BlogEditorContextMenuActionEnum.INSERT_HOVER_CARD,
  BlogEditorContextMenuActionEnum.VOCAB_NEWS,
  BlogEditorContextMenuActionEnum.BORDER_AND_SHADING,
];

export const DictionaryBlogEditorContextMenuPresets: BlogEditorContextMenuActionEnum[] = [
  BlogEditorContextMenuActionEnum.COPY,
  BlogEditorContextMenuActionEnum.PASTE,
  BlogEditorContextMenuActionEnum.PASTE_WITHOUT_FORMAT,
  BlogEditorContextMenuActionEnum.HYPERLINK,
  BlogEditorContextMenuActionEnum.BORDER_AND_SHADING,
];
